module.exports = __webpack_public_path__ + "img/T4-A-xh_18.698a7591.png";